"use strict";

/**
 * Splits the locale string to access the country and language
 * @param {string} locale the locale (ex: 'en_US')
 * @return {{language: string, countryCode: string}}
 */
function getLocaleInfo(locale) {
  let language = "";
  let countryCode = "";
  
  const splitParams = locale.split("_");
  if (splitParams.length === 1) {
    countryCode = splitParams[0];
  } else {
    language = splitParams[0];
    countryCode = splitParams[1];
  }
  
  return {
    countryCode: countryCode,
    language: language
  };
}
  

module.exports = {
  getLocaleInfo
};
